import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UploadedFile {
  id: string;
  name: string;
  status: 'Pending' | 'Uploading' | 'Complete' | 'Failed';
  uploadedAt: string;
}

interface UploadedFilesState {
  uploadedFiles: UploadedFile[];
}

const initialState: UploadedFilesState = {
  uploadedFiles: [],
};

const uploadedFilesSlice = createSlice({
  name: 'uploadedFiles',
  initialState,
  reducers: {
    addUploadedFilesAction: (state, action: PayloadAction<UploadedFile[]>) => {
      state.uploadedFiles = [...state.uploadedFiles, ...action.payload];
    },
    updateFileStatusAction: (state, action: PayloadAction<{ id: string; status: 'Pending' | 'Uploading' | 'Complete' | 'Failed' }>) => {
      const file = state.uploadedFiles.find(f => f.id === action.payload.id);
      if (file) file.status = action.payload.status;
    },
    removeUploadedFileAction: (state, action: PayloadAction<string>) => {
      state.uploadedFiles = state.uploadedFiles.filter(f => f.id !== action.payload);
    },
    clearUploadedFilesAction: state => {
      state.uploadedFiles = [];
    },
  },
});

export const { addUploadedFilesAction, updateFileStatusAction, removeUploadedFileAction, clearUploadedFilesAction } =
  uploadedFilesSlice.actions;
export default uploadedFilesSlice.reducer;
